<template>
  <p
    class="text-sm font-semibold uppercase tracking-widest"
    :class="themes[theme]"
  >
    <slot />
  </p>
</template>

<script>
export default {
  name: "CoreTitle",
  props: {
    theme: {
      default: "text",
    },
  },
  data() {
    return {
      themes: {
        text: " text-darkestGray",
        primary: "text-primary",
      },
    };
  },
};
</script>

<style lang="scss" scoped></style>
